var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"event-handling-container"},[_c('div',{staticClass:"event-title"},[_vm._v("\n            财务报表\n        ")])])])
}]

export { render, staticRenderFns }